interface HasGapAnalysisDataResult {
    /**
     * True if the periodSelection has detection data
     */
    hasDetectionData: boolean;
    /**
     * True if the hasPerformanceData has detection data
     */
    hasPerformanceData: boolean;
}

/**
 * Determines whether a given periodSelection has detection data and performance data.
 * @param periodSelection - {@link GapAnalysisPeriodSelection} or null
 * @returns an {@link HasGapAnalysisDataResult} object
 */
export const hasGapAnalysisData = (
    periodSelection: GapAnalysisPeriodSelection | null,
    trqkGap: TrqkGap | null,
): HasGapAnalysisDataResult => {
    const start = periodSelection?.performance_period_start
        ? new Date(periodSelection.performance_period_start)
        : null;
    const end = periodSelection?.performance_period_end
        ? new Date(periodSelection.performance_period_end)
        : null;
    const detectionsStart = periodSelection?.detection_data_start
        ? new Date(periodSelection.detection_data_start)
        : null;
    const detectionsEnd = periodSelection?.detection_data_end
        ? new Date(periodSelection.detection_data_end)
        : null;

    const hasDetectionsInPeriodSelection =
        periodSelection !== null &&
        start !== null &&
        end !== null &&
        detectionsStart !== null &&
        detectionsEnd !== null &&
        detectionsStart <= end &&
        detectionsEnd >= start;

    const hasDetectionBatch = (trqkGap?.detection_batch ?? null) !== null;
    const hasPerformanceData = periodSelection?.pro_statement_present ?? false;

    return {
        hasDetectionData: hasDetectionsInPeriodSelection || hasDetectionBatch,
        hasPerformanceData,
    };
};
